import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';

import { AlertIcon } from '../../../../common-components/elements/icon/svgs/AlertIcon';
import { VideaInfoOutlinedIcon } from '../../../../common-components/elements/VideaIcons/VideaIcons';
import { VideaTypography } from '../../../../common-components/elements/VideaTypography/VideaTypography';
import { useComputeMessageForFindings } from '../../../annotator/multiFileViewer/findingViewer/utils';
import type { ImageObject } from '../../../annotator/types';

const InfoIcon = styled(VideaInfoOutlinedIcon)`
  position: absolute;
  bottom: 1.5em;
  left: 0.75em;
`;

const AlertIconContainer = styled.div`
  color: red;
  position: absolute;
  bottom: 1.5em;
  left: 0.75em;
`;

export const ModelMessaging = ({
  activeImage,
}: {
  activeImage: ImageObject;
}) => {
  const computeMessagingForNoAiFindings = useComputeMessageForFindings();
  const { noFindingsMessages, hasModelErrors } =
    computeMessagingForNoAiFindings(activeImage);
  const messages = noFindingsMessages.map((message: string) => (
    <VideaTypography variant="labelExtrasmall" component="p" margin="0.5em">
      {message}
    </VideaTypography>
  ));

  return (
    messages && (
      <Tooltip title={messages}>
        {hasModelErrors ? (
          <AlertIconContainer>
            <AlertIcon />
          </AlertIconContainer>
        ) : (
          <InfoIcon />
        )}
      </Tooltip>
    )
  );
};
